// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_B08","question":"styles_question__3bJpN","description":"styles_description__3RbEA"};